import self from "../img/self.png";
// import mock1 from "../img/mock1.png";
// import mock2 from "../img/mock2.png";
// import mock3 from "../img/mock3.png";
// import mock4 from "../img/mock4.png";
// import mock5 from "../img/mock5.png";

// Hi there! Thanks for checking out my portfolio template. Be sure to read the comments to get a better understanding of how to make this template work best for you!

export let colors = ["#00FFA4", "#A668FF"];
// I highly recommend using a gradient generator like https://gradientgenerator.paytonpierce.dev/ to generate a pair of colors that you like.
// These colors will be used to style your name on the homepage, the background of your picture, and some other accents throughout the site.

// So let's get started! Some of the info below is pretty self-explanatory, like 'firstName' and 'bio'.
// I'll try to explain anything that might not be obvious right off the bat :)
// I recommend looking at the template example live using "npm start" to get an idea of what each of the values mean.

export const infoEn = {
  firstName: "Berkant",
  lastName: "Aslan",
  initials: "Berkant Aslan", // the example uses first and last, but feel free to use three or more if you like.
  position: "AI & Digital Transformation Engineer",
  selfPortrait: self, // don't change this unless you want to name your self-portrait in the "img" folder something else!
  gradient: `-webkit-linear-gradient(135deg, ${colors})`, // don't change this either
  baseColor: colors[0],
  miniBio: [
    { emoji: "☕", text: "Feeds on Filter Coffee" },
    { emoji: "🌎", text: "Lives in Turkey" },
    { emoji: "💼", text: "AI & Digital Transformation Engineer at Sanver" },
    { emoji: "📧", text: "hello@berkantaslan.com" },
  ],
  socials: [
    {
      link: "https://www.linkedin.com/in/berkantaslan/",
      icon: "fa fa-linkedin",
      label: "linkedin",
    },
    {
      link: "https://github.com/berkantaslan",
      icon: "fa fa-github",
      label: "github",
    },
    {
      link: "https://www.kaggle.com/berkantaslan",
      icon: "kaggle-svg",
      label: "kaggle",
    },
    {
      link: "https://www.instagram.com/berkant.aslan/",
      icon: "fa fa-instagram",
      label: "instagram",
    },
    {
      link: "https://www.academia.edu/attachments/134448546/download_file",
      icon: "fa fa-file-pdf-o",
      label: "cv",
    },
    {
      link: "mailto:hello@berkantaslan.com",
      icon: "fa fa-envelope",
      label: "email",
    },

    // Feel free to remove any of these that you don't have.
    // I'll write an FAQ on how to add new ones later, let me know if you have a request for an icon!
    // Just change the links so that they lead to your social profiles.
  ],
  bio: "Hello, I am someone who wants to improve myself in every subject, who attaches great importance to projects, general culture and foreign languages. I am social, compatible with teamwork, have managerial skills and experiences, can think analytically and creatively, can learn very easily and quickly, has experience in academic articles and has academic goals, is energetic and result-oriented, loves writing and producing, honest, respectful, dear, active, brave, hard-working, combative and loyal. My development and learning in my skills related to Artificial Intelligence, Data Science, Big Data, Image Processing and Business Intelligence continues. I am a married person who loves people very much, is devoted to humanity, in love with Turkey, respectful and dear, and loves his wife very much.",
  skills: {
    proficientWith: [
      "python",
      "mongodb",
      "react",
      "javascript",
      "html5",
      "css3",
      "c#",
      "c",
      "c++",
      "r",
    ],
    exposedTo: [".net"],
  },
  hobbies: [
    { label: "Reading Books and Magazines", emoji: "📖" },
    { label: "Watching Movies and Series", emoji: "🎥" },
    { label: "Following Technology", emoji: "🚀" },
    { label: "Drawing and Painting", emoji: "🖌️" },
    { label: "Listening Music", emoji: "🎧" },
    { label: "Playing Football", emoji: "⚽" },
    { label: "Foot Tennis", emoji: "⚽" },
    { label: "Swimming", emoji: "🏊" },
    { label: "Running", emoji: "🏃" },
    { label: "Cycling", emoji: "🚴" },
    { label: "Cooking", emoji: "🍳" },
    { label: "Traveling", emoji: "✈️" },
    { label: "Hiking", emoji: "🥾" },
    { label: "Astronomy", emoji: "🔭" },
    { label: "Entrepreneurship", emoji: "💡" },
    // Add any other hobbies you have
    // Same as above, change the emojis to match / relate to your hobbies or interests.
    // You can also remove the emojis if you'd like, I just think they look cute :P
  ],
  portfolio: [
    // This is where your portfolio projects will be detailed
    /*{
      title: "Project 1",
      live: "https://paytonpierce.dev", //this should be a link to the live version of your project, think github pages, netlify, heroku, etc. Or your own domain, if you have it.
      source: "https://github.com/paytonjewell", // this should be a link to the **repository** of the project, where the code is hosted.
      image: mock1
    },
    {
      title: "Project 2",
      live: "https://paytonpierce.dev",
      source: "https://github.com/paytonjewell",
      image: mock2
    },
    {
      title: "Project 3",
      live: "https://paytonpierce.dev",
      source: "https://github.com/paytonjewell",
      image: mock3
    },
    {
      title: "Project 4",
      live: "https://paytonpierce.dev",
      source: "https://github.com/paytonjewell",
      image: mock4
    },
    {
      title: "Project 5",
      live: "https://paytonpierce.dev",
      source: "https://github.com/paytonjewell",
      image: mock5
    }*/
  ],
};
